import { render, staticRenderFns } from "./HistoryGroup.vue?vue&type=template&id=11b1e040&scoped=true"
import script from "./HistoryGroup.vue?vue&type=script&lang=ts"
export * from "./HistoryGroup.vue?vue&type=script&lang=ts"
import style0 from "./HistoryGroup.vue?vue&type=style&index=0&id=11b1e040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1e040",
  null
  
)

export default component.exports